import * as $ from "jquery";

export default class CategorySelector {
  domRoot: JQuery<HTMLElement>;
  select: JQuery<HTMLElement>;
  
  constructor(domRoot: HTMLElement) {
    this.domRoot = $(domRoot);
    this.select = $('.component--category-selector__select', this.domRoot);
    this.init();
  }

  init() {
    this.select.on('change', this.handleChange.bind(this));
  }

  handleChange(e) {
    window.location.replace(e.target.value);
  }
}
